"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCardAliasToFormattedCCAlias = transformCardAliasToFormattedCCAlias;
function transformCardAliasToFormattedCCAlias(cardAlias) {
    return cardAlias.replace(/.+(\d{2})$/, "##$1");
}
//# sourceMappingURL=transformCardAliasToFormattedCCAlias.js.map